const fakeData = {
	// ── sidebar sections ──
	sidebarSections: [
		{
			label: 'My day',
			items: [
				{
					name: 'Work Queue',
					count: 13,
					countColor: 'red',
					defaultActive: true,
				},
				{ name: 'Alerts', count: 9, countColor: 'red' },
				{ name: 'Activity feed', count: 18, countColor: 'gray' },
			],
		},
		{
			label: 'Coverage',
			items: [
				{ name: 'All LPs', count: 22, countColor: 'gray' },
				{ name: 'Tier 1', count: 12, countColor: 'gray' },
				{ name: 'At risk', count: 2, countColor: 'red' },
				{ name: 'Re-up pipeline' },
			],
		},
		{
			label: 'Entities',
			items: [
				{ name: 'Fund V', count: 'Watch', countColor: 'amber' },
				{ name: 'Fund IV' },
				{ name: 'All entities' },
			],
		},
	],

	// ── work queue items ──
	workQueueItems: [
		{
			section: 'Overdue',
			items: [
				{
					id: 'wirefollow',
					drawerType: 'wirefollow',
					dotColor: 'red',
					text: 'Follow up: Statewide Teachers — capital call wire unconfirmed',
					sub: 'Due 3 days ago · Fund IV',
					ctaLabel: 'click to act',
					chipLabel: 'Send follow-up',
					chipVariant: 'primary',
					variant: 'featured',
				},
				{
					id: 'vdr-qa-breach',
					drawerType: 'vdr-qa-breach',
					dotColor: 'vdr',
					text: 'Q&A SLA breach — LP asked about fee structure in Raise VDR',
					sub: '6 days without response · Raise VDR source',
					ctaLabel: 'click to act',
					chipLabel: 'Draft response + publish to Raise VDR',
					chipVariant: 'vdr',
					variant: 'vdr-featured',
					vdrBadge: '↔ Open in Raise VDR',
				},
				{
					id: 'vdr-ioi-queue',
					drawerType: 'vdr-ioi-queue',
					dotColor: 'vdr',
					text: 'IOI received — Hartwell Family Office submitted $30M in Raise VDR',
					sub: 'Today 11:23 AM · Critical',
					ctaLabel: 'confirm',
					chipLabel: 'Confirm in pipeline',
					chipVariant: 'vdr',
					variant: 'vdr-featured',
					vdrBadge: '↔ Open in Raise VDR',
				},
			],
		},
		{
			section: 'Due this week',
			items: [
				{
					id: 'q1-report',
					dotColor: 'red',
					text: 'Q1 report not accessed — Hartwell Family Office',
					sub: 'Delivered 11 days ago · no portal view logged',
				},
				{
					id: 'nda-stalled',
					dotColor: 'vdr',
					text: 'NDA stalled — Pacific Coast Foundation: opened but not signed, 4 days elapsed',
					sub: 'Raise VDR source',
					variant: 'vdr-sourced',
					vdrBadge: '↔ Open in Raise VDR',
				},
				{
					id: 'lpac-preread',
					dotColor: 'amber',
					text: 'LPAC pre-read — Fund IV semi-annual meeting',
					sub: 'Due in 2 days · 6 LPAC members',
				},
			],
		},
		{
			section: 'Upcoming',
			items: [
				{
					id: 'no-vdr-engagement',
					dotColor: 'vdr',
					text: 'No VDR engagement — Greenfield Foundation: access granted 6 days, zero activity',
					sub: 'Raise VDR source · inactivity threshold',
					variant: 'vdr-sourced',
					vdrBadge: '↔ View LP activity',
				},
				{
					id: 'cohort-gap',
					dotColor: 'vdr',
					text: 'Cohort gap — 3 LPs in cohort not yet contacted: NDA not sent',
					sub: 'Raise VDR source · 48h threshold',
					variant: 'vdr-sourced',
					vdrBadge: '↔ Cohort manager',
				},
				{
					id: 'next-fund-preview',
					dotColor: 'gray',
					text: 'Next-fund preview call — 4 Tier 1 re-up candidates',
					sub: 'Fund V pre-marketing · High re-up score',
				},
				{
					id: 'k1-followup',
					dotColor: 'gray',
					text: 'K-1 follow-up — 3 LPs with no download logged',
					sub: 'K-1s distributed Mar 10',
				},
			],
		},
	],

	// ── alert items ──
	alertItems: [
		{
			section: 'Critical',
			items: [
				{
					id: 'vdr-ioi-alert',
					drawerType: 'vdr-ioi-alert',
					icon: '!',
					iconColor: 'vdr',
					text: 'IOI submitted — Hartwell Family Office: $30M in Raise VDR',
					sub: 'Today 11:23 AM · pipeline update required',
					ctaLabel: 'confirm',
					chipLabel: 'Confirm + update pipeline',
					chipVariant: 'vdr',
					variant: 'vdr-featured',
					vdrBadge: '↔ Open in Raise VDR',
				},
				{
					id: 'carver-alert',
					drawerType: 'carver-alert',
					icon: '!',
					iconColor: 'red',
					text: 'Health signal: At Risk — Carver State Pension',
					sub: 'No contact 94 days · 2 open items',
					ctaLabel: 'click to review',
					chipLabel: 'View signal + draft outreach',
					chipVariant: 'primary',
					variant: 'featured',
				},
				{
					id: 'nda-declined',
					icon: '!',
					iconColor: 'vdr',
					text: 'NDA declined — Northgate Insurance declined NDA in Raise VDR',
					sub: 'Today 9:02 AM · IR decision required',
					chipLabel: 'Review + log outcome',
					chipVariant: 'vdr',
					variant: 'vdr-sourced',
					vdrBadge: '↔ View in Raise VDR',
				},
			],
		},
		{
			section: 'Act now',
			items: [
				{
					id: 'vdr-high-engagement',
					drawerType: 'vdr-high-engagement',
					icon: '~',
					iconColor: 'vdr',
					text: 'High engagement — Meridian Endowment: 38 min session, track record 3×',
					sub: 'Today 9:41 AM · Raise VDR source',
					ctaLabel: 'click to act',
					chipLabel: 'View engagement + draft follow-up',
					chipVariant: 'vdr',
					variant: 'vdr-featured',
					vdrBadge: '↔ View LP activity',
				},
			],
		},
		{
			section: 'Acknowledge',
			items: [
				{
					id: 'lp-inactivity',
					icon: '~',
					iconColor: 'vdr',
					text: 'LP inactivity — Greenfield Foundation: VDR access 6 days, zero engagement',
					sub: 'Raise VDR source',
					variant: 'vdr-sourced',
					vdrBadge: '↔ View LP activity',
				},
				{
					id: 'northgate-reup',
					drawerType: 'northgate-reup',
					icon: '~',
					iconColor: 'amber',
					text: 'Re-up score downgrade — Northgate Insurance',
					sub: 'High → Medium · DPI sensitivity · 61 days',
					ctaLabel: 'click to review',
					chipLabel: 'Review score breakdown',
					chipVariant: 'primary',
					variant: 'featured',
				},
				{
					id: 'phase-advance',
					icon: 'i',
					iconColor: 'vdr',
					text: 'Phase advance — deal advanced to Full Docs: 4 LPs now in diligence',
					sub: 'Today 8:00 AM · Raise VDR source',
					variant: 'vdr-sourced',
					vdrBadge: '↔ View raise overview',
				},
				{
					id: 'first-close',
					icon: 'i',
					iconColor: 'blue',
					text: 'First-close confidence: Watch — Fund V',
					sub: '6 soft commits · 2 of 10 hard commits',
				},
			],
		},
	],

	// ── activity feed items ──
	activityFeedItems: [
		{
			id: 'meridian-ppm-feed',
			drawerType: 'meridian-ppm',
			tag: '↔ VDR',
			tagColor: 'vdr',
			text: 'Meridian Endowment — 3× track record access, 38 min in Raise VDR',
			sub: 'Today 9:41 AM',
			ctaLabel: 'click to act',
			chipLabel: 'View engagement + draft follow-up',
			chipVariant: 'vdr',
			variant: 'vdr-featured',
		},
		{
			id: 'hartwell-ioi-feed',
			tag: '↔ VDR',
			tagColor: 'vdr',
			text: 'Hartwell Family Office — IOI submitted: $30M in Fund V co-invest room',
			sub: 'Today 11:23 AM · pipeline update required',
			subCta: 'click to open Raise VDR alerts →',
			variant: 'vdr-sourced',
		},
		{
			id: 'statewide-nda-feed',
			tag: '↔ VDR',
			tagColor: 'vdr',
			text: 'Statewide Teachers Pension — NDA executed in Raise VDR',
			sub: 'Today 8:07 AM · access advanced to full docs',
			subCta: 'open Raise VDR →',
			variant: 'vdr-sourced',
		},
		{
			id: 'pacific-qa-feed',
			tag: '↔ VDR',
			tagColor: 'vdr',
			text: 'Pacific Coast Foundation — Q&A submitted in Raise VDR: fee structure query',
			sub: 'Mar 19 · SLA clock started',
			subCta: 'draft response in Raise VDR →',
			variant: 'vdr-sourced',
		},
		{
			id: 'deal-phase-feed',
			tag: '↔ VDR',
			tagColor: 'vdr',
			text: 'Deal phase advanced to Full Docs — 4 LPs now in diligence',
			sub: 'Today 8:00 AM · access levels updated',
			subCta: 'open Raise VDR →',
			variant: 'vdr-sourced',
		},
		{
			id: 'meridian-signal-feed',
			drawerType: 'meridian-ppm',
			tag: 'Signal',
			tagColor: 'teal',
			text: 'Meridian Endowment — 3× PPM access, 42 min (IR Workstation signal)',
			sub: 'Today 8:14 AM',
			chipLabel: 'Draft follow-up email',
			chipVariant: 'primary',
			variant: 'featured',
		},
		{
			id: 'calstrs-news',
			tag: 'News',
			tagColor: 'gray',
			text: 'CalSTRS increases PE allocation target to 16%',
			sub: 'Today 6:30 AM · WSJ',
		},
		{
			id: 'q1-reports-feed',
			tag: 'Report',
			tagColor: 'green',
			text: 'Q1 reports delivered — 34 of 36 LPs confirmed access',
			sub: 'Yesterday · 2 LPs no view logged',
		},
		{
			id: 'email-bounce-feed',
			tag: 'Signal',
			tagColor: 'teal',
			text: 'Email bounce — Brookfield Municipal Pension primary contact',
			sub: 'Mar 18 · Email Sync detection',
		},
	],

	// ── fund dashboard kpis ──
	fundDashboardKPIs: [
		{
			label: 'Total committed',
			value: '$3.2B',
			sub: '5 vehicles',
			subColor: 'neutral',
		},
		{
			label: 'Blended net IRR',
			value: '18.4%',
			sub: '+2.1pp vs benchmark',
			subColor: 'up',
		},
		{
			label: 'Total DPI',
			value: '1.6×',
			sub: 'Entities I–IV',
			subColor: 'neutral',
		},
		{
			label: '↔ VDR signals today',
			value: '7',
			sub: 'Open Raise VDR →',
			vdr: true,
		},
	],

	// ── fund cards ──
	fundCards: [
		{
			name: 'Buyout Fund I',
			vintage: '2008 · Fully realised',
			pill: { label: 'Wind-down complete', color: 'gray' },
			stats: [
				{ label: 'Net IRR', value: '21.3%' },
				{ label: 'DPI', value: '2.4×' },
			],
			footer: 'Final realisation 2016',
		},
		{
			name: 'Buyout Fund II',
			vintage: '2012 · Fully realised',
			pill: { label: 'Wind-down complete', color: 'gray' },
			stats: [
				{ label: 'Net IRR', value: '19.7%' },
				{ label: 'DPI', value: '2.1×' },
			],
			footer: 'Final realisation 2020',
		},
		{
			name: 'Buyout Fund III',
			vintage: '2016 · Near end of life',
			pill: { label: 'Extension under review', color: 'amber' },
			stats: [
				{ label: 'Net IRR', value: '16.2%' },
				{ label: 'DPI', value: '1.4×' },
			],
			bar: { percent: 78, color: 'amber' },
			footer: 'Term expires Dec 2026',
		},
		{
			name: 'Buyout Fund IV',
			vintage: '2019 · In harvest',
			pill: { label: 'Active · harvesting', color: 'teal' },
			stats: [
				{ label: 'Net IRR', value: '18.1%' },
				{ label: 'DPI', value: '0.9×' },
			],
			bar: { percent: 52, color: 'green' },
			footer: '2 exits expected H1 2026',
		},
		{
			name: 'Buyout Fund V',
			vintage: '2025 · Active Fundraise',
			pill: { label: 'Watch · 41 days to FC', color: 'amber' },
			stats: [
				{ label: 'Committed', value: '$612M', valueColor: 'blue' },
				{ label: 'First close target', value: '$750M' },
			],
			bar: { percent: 82, color: 'amber' },
			footer: 'Click for Fund V Fundraise Dashboard →',
			footerHighlight: true,
			isFundV: true,
			activeRaise: true,
		},
	],

	// ── active fund detail (currently Fund V) ──
	activeFundDetail: {
		title: 'Fund V Raise Dashboard',
		meta: 'First close Apr 30 • 41 days',
		badges: [{ label: 'Watch', color: 'amber' }],
		kpis: [
			{
				label: 'Capital committed',
				value: '$612M',
				sub: '+$85M this week',
				subColor: 'up',
			},
			{
				label: 'To first close',
				value: '82%',
				sub: '$138M gap',
				subColor: 'warn',
			},
			{
				label: 'LPs committed / target',
				value: '8 / 22',
				sub: '6 soft · 8 in DD',
				subColor: 'neutral',
			},
			{
				label: 'Re-up conversion',
				value: '67%',
				sub: '6 of 9',
				subColor: 'neutral',
			},
			{
				label: 'Avg. days to soft circle',
				value: '41 days',
				sub: '+6 vs Fund IV',
				subColor: 'down',
			},
			{
				label: '↔ VDR signals today',
				value: '7',
				sub: 'Open Raise VDR →',
				vdr: true,
			},
		],
		pipeline: [
			{
				lp: 'Statewide Teachers Pension',
				type: 'Public pension',
				target: '$100M',
				pipelineStatus: { label: 'Committed', color: 'green' },
				reupScore: { label: 'High', color: 'green', drawerType: 'reup-high' },
				vdrStatus: { label: 'NDA Complete', color: 'vdr' },
			},
			{
				lp: 'Meridian Endowment',
				type: 'Endowment',
				target: '$75M',
				pipelineStatus: { label: 'Soft circle', color: 'amber' },
				reupScore: { label: 'High', color: 'green', drawerType: 'reup-high' },
				vdrStatus: { label: 'Reviewing', color: 'vdr' },
			},
			{
				lp: 'Hartwell Family Office',
				type: 'Family office',
				target: '$30M',
				pipelineStatus: { label: 'Committed', color: 'green' },
				reupScore: { label: 'High', color: 'green', drawerType: 'reup-high' },
				vdrStatus: { label: 'IOI Submitted', color: 'green' },
				highlight: true,
			},
			{
				lp: 'Pacific Coast Foundation',
				type: 'Foundation',
				target: '$50M',
				pipelineStatus: { label: 'In diligence', color: 'blue' },
				reupScore: { label: 'High', color: 'green', drawerType: 'reup-high' },
				vdrStatus: { label: 'NDA Pending', color: 'vdr' },
			},
			{
				lp: 'Carver State Pension',
				type: 'Public pension',
				target: '$80M',
				pipelineStatus: { label: 'In diligence', color: 'blue' },
				reupScore: {
					label: 'Medium',
					color: 'amber',
					drawerType: 'reup-medium',
				},
				vdrStatus: { label: 'In Diligence', color: 'vdr' },
			},
			{
				lp: 'Northgate Insurance',
				type: 'Insurance',
				target: '$60M',
				pipelineStatus: { label: 'Stalled', color: 'red' },
				reupScore: {
					label: 'Medium',
					color: 'amber',
					drawerType: 'reup-medium',
				},
				vdrStatus: { label: 'NDA Declined', color: 'red' },
			},
			{
				lp: 'Greenfield Foundation',
				type: 'Foundation',
				target: '$25M',
				pipelineStatus: { label: 'Stalled', color: 'red' },
				reupScore: {
					label: 'Medium',
					color: 'amber',
					drawerType: 'reup-medium',
				},
				vdrStatus: { label: 'No engagement', color: 'vdr' },
			},
			{
				lp: 'Brookfield Municipal Pension',
				type: 'Public pension',
				target: '$70M',
				pipelineStatus: { label: 'Contacted', color: 'gray' },
				reupScore: {
					label: 'Unknown',
					color: 'gray',
					drawerType: 'reup-unknown',
				},
				vdrStatus: { label: 'Not in cohort', color: 'gray' },
			},
		],
		qa: [
			{
				lp: 'Pacific Coast Foundation',
				topic: 'Fund V fee structure',
				pill: { label: 'Overdue · VDR source', color: 'red' },
				sub: 'Submitted in Raise VDR Mar 19 · 5-day SLA exceeded',
				overdue: true,
				vdr: true,
			},
			{
				lp: 'Meridian Endowment',
				topic: 'co-investment rights detail',
				pill: { label: 'Overdue · VDR source', color: 'red' },
				sub: 'Submitted in Raise VDR Mar 15 · 5-day SLA exceeded',
				overdue: true,
			},
			{
				lp: 'Northgate Insurance',
				topic: 'ESG reporting methodology',
				pill: { label: 'Due Mar 24', color: 'amber' },
				sub: 'Received Mar 19',
			},
			{
				lp: 'Hartwell Family Office',
				topic: 'recycling provision',
				pill: { label: 'Due Mar 25', color: 'gray' },
				sub: 'Received Mar 20',
			},
		],
	},

	// ── co-invest dashboard kpis ──
	coInvestKPIs: [
		{ label: 'Active opportunities', value: '3' },
		{ label: 'Total exposure', value: '$285M' },
		{ label: 'LPs with co-invest rights', value: '9' },
		{
			label: '↔ VDR signals today',
			value: '7',
			sub: 'Open Raise VDR →',
			vdr: true,
		},
	],

	// ── active entity detail ──
	activeEntityDetail: {
		title: 'Fund V',
		meta: 'Active Fundraise · 41 days to first close',
		badges: [{ label: 'Watch', color: 'amber' }],
		kpis: [
			{
				label: 'Capital committed',
				value: '$612M',
				sub: '+$85M this week',
				subColor: 'up',
			},
			{
				label: 'To first close',
				value: '82%',
				sub: '$138M gap',
				subColor: 'warn',
			},
			{
				label: 'LPs committed / target',
				value: '8 / 22',
				sub: '6 soft · 8 in DD',
				subColor: 'neutral',
			},
			{
				label: 'Re-up conversion',
				value: '67%',
				sub: '6 of 9',
				subColor: 'neutral',
			},
			{
				label: 'Avg. days to soft circle',
				value: '41 days',
				sub: '+6 vs Fund IV',
				subColor: 'down',
			},
			{
				label: '↔ VDR signals today',
				value: '7',
				sub: 'Open Raise VDR →',
				vdr: true,
			},
		],
		pipeline: [
			{
				lp: 'Statewide Teachers Pension',
				type: 'Public pension',
				target: '$100M',
				pipelineStatus: { label: 'Committed', color: 'green' },
				reupScore: { label: 'High', color: 'green', drawerType: 'reup-high' },
				vdrStatus: { label: 'NDA Complete', color: 'vdr' },
			},
			{
				lp: 'Meridian Endowment',
				type: 'Endowment',
				target: '$75M',
				pipelineStatus: { label: 'Soft circle', color: 'amber' },
				reupScore: { label: 'High', color: 'green', drawerType: 'reup-high' },
				vdrStatus: { label: 'Reviewing', color: 'vdr' },
			},
			{
				lp: 'Hartwell Family Office',
				type: 'Family office',
				target: '$30M',
				pipelineStatus: { label: 'Committed', color: 'green' },
				reupScore: { label: 'High', color: 'green', drawerType: 'reup-high' },
				vdrStatus: { label: 'IOI Submitted', color: 'green' },
				highlight: true,
			},
			{
				lp: 'Pacific Coast Foundation',
				type: 'Foundation',
				target: '$50M',
				pipelineStatus: { label: 'In diligence', color: 'blue' },
				reupScore: { label: 'High', color: 'green', drawerType: 'reup-high' },
				vdrStatus: { label: 'NDA Pending', color: 'vdr' },
			},
			{
				lp: 'Carver State Pension',
				type: 'Public pension',
				target: '$80M',
				pipelineStatus: { label: 'In diligence', color: 'blue' },
				reupScore: {
					label: 'Medium',
					color: 'amber',
					drawerType: 'reup-medium',
				},
				vdrStatus: { label: 'In Diligence', color: 'vdr' },
			},
			{
				lp: 'Northgate Insurance',
				type: 'Insurance',
				target: '$60M',
				pipelineStatus: { label: 'Stalled', color: 'red' },
				reupScore: {
					label: 'Medium',
					color: 'amber',
					drawerType: 'reup-medium',
				},
				vdrStatus: { label: 'NDA Declined', color: 'red' },
			},
			{
				lp: 'Greenfield Foundation',
				type: 'Foundation',
				target: '$25M',
				pipelineStatus: { label: 'Stalled', color: 'red' },
				reupScore: {
					label: 'Medium',
					color: 'amber',
					drawerType: 'reup-medium',
				},
				vdrStatus: { label: 'No engagement', color: 'vdr' },
			},
			{
				lp: 'Brookfield Municipal Pension',
				type: 'Public pension',
				target: '$70M',
				pipelineStatus: { label: 'Contacted', color: 'gray' },
				reupScore: {
					label: 'Unknown',
					color: 'gray',
					drawerType: 'reup-unknown',
				},
				vdrStatus: { label: 'Not in cohort', color: 'gray' },
			},
		],
		qa: [
			{
				lp: 'Pacific Coast Foundation',
				topic: 'Fund V fee structure',
				pill: { label: 'Overdue · VDR source', color: 'red' },
				sub: 'Submitted in Raise VDR Mar 19 · 5-day SLA exceeded',
				overdue: true,
				vdr: true,
			},
			{
				lp: 'Meridian Endowment',
				topic: 'co-investment rights detail',
				pill: { label: 'Overdue · VDR source', color: 'red' },
				sub: 'Submitted in Raise VDR Mar 15 · 5-day SLA exceeded',
				overdue: true,
			},
			{
				lp: 'Northgate Insurance',
				topic: 'ESG reporting methodology',
				pill: { label: 'Due Mar 24', color: 'amber' },
				sub: 'Received Mar 19',
			},
			{
				lp: 'Hartwell Family Office',
				topic: 'recycling provision',
				pill: { label: 'Due Mar 25', color: 'gray' },
				sub: 'Received Mar 20',
			},
		],
	},

	// ── co-invest cards ──
	coInvestCards: [
		{
			name: 'Portfolio Co. C — Add-on',
			sub: 'Fund IV · Window closes Fri',
			pill: { label: 'Window closes Fri', color: 'amber' },
			stats: [
				{ label: 'Co-invest tranche', value: '$40M available' },
				{ label: 'IOIs received', value: '3 of 9 eligible' },
				{ label: 'VDR phase', pill: { label: 'Full Docs', color: 'vdr' } },
			],
			vdrBadge: '↔ Open Raise VDR',
			actionLabel: 'Manage',
		},
		{
			name: 'Portfolio Co. F — New investment',
			sub: 'Fund V · Pre-close co-invest',
			pill: { label: 'NDA phase', color: 'blue' },
			stats: [
				{ label: 'Co-invest tranche', value: '$30M target' },
				{ label: 'NDAs executed', value: '2 of 5 targeted' },
				{ label: 'VDR phase', pill: { label: 'NDA', color: 'vdr' } },
			],
			vdrBadge: '↔ NDA workflow in Raise VDR',
			actionLabel: 'Manage',
		},
		{
			name: 'Portfolio Co. A — Existing',
			sub: 'Fund III · Post-close reporting',
			pill: { label: 'Monitoring', color: 'teal' },
			stats: [
				{ label: 'Current MoM', value: '2.1×' },
				{ label: 'IRR to date', value: '22.4%' },
				{
					label: 'Next report',
					pill: { label: 'Q1 due Apr 30', color: 'gray' },
				},
			],
			footerText: 'Exit expected H2 2026',
			actionLabel: 'View detail',
		},
	],

	// ── LP lookup options ──
	lpOptions: [
		{
			name: 'Meridian Endowment',
			initials: 'ME',
			type: 'Endowment',
			tier: 'Tier 1',
			reup: 'High',
			health: 'Stable',
			commit: '$75M',
			aum: '$4.2B',
			lastContact: '18 days',
			openItems: 1,
			vdrStatus: 'Reviewing',
		},
		{
			name: 'Statewide Teachers Pension',
			initials: 'ST',
			type: 'Public pension',
			tier: 'Tier 1',
			reup: 'High',
			health: 'Strong',
			commit: '$100M',
			aum: '$12.1B',
			lastContact: '7 days',
			openItems: 0,
			vdrStatus: 'NDA Complete',
		},
		{
			name: 'Pacific Coast Foundation',
			initials: 'PC',
			type: 'Foundation',
			tier: 'Tier 1',
			reup: 'High',
			health: 'Stable',
			commit: '$60M',
			aum: '$2.8B',
			lastContact: '12 days',
			openItems: 1,
			vdrStatus: 'In Diligence',
		},
		{
			name: 'Northgate Insurance',
			initials: 'NI',
			type: 'Insurance',
			tier: 'Tier 1',
			reup: 'Medium',
			health: 'Stable',
			commit: '$60M',
			aum: '$8.3B',
			lastContact: '61 days',
			openItems: 0,
			vdrStatus: 'NDA Declined',
		},
		{
			name: 'Carver State Pension',
			initials: 'CS',
			type: 'Public pension',
			tier: 'Tier 1',
			reup: 'Medium',
			health: 'At Risk',
			commit: '$80M',
			aum: '$6.7B',
			lastContact: '94 days',
			openItems: 2,
			vdrStatus: 'No access',
		},
		{
			name: 'Hartwell Family Office',
			initials: 'HF',
			type: 'Family office',
			tier: 'Tier 2',
			reup: 'High',
			health: 'Stable',
			commit: '$30M',
			aum: '$850M',
			lastContact: '22 days',
			openItems: 0,
			vdrStatus: 'IOI Submitted',
		},
		{
			name: 'Greenfield Foundation',
			initials: 'GF',
			type: 'Foundation',
			tier: 'Tier 2',
			reup: 'Medium',
			health: 'Stable',
			commit: '$25M',
			aum: '$1.1B',
			lastContact: '31 days',
			openItems: 1,
			vdrStatus: 'No engagement',
		},
		{
			name: 'Brookfield Municipal Pension',
			initials: 'BM',
			type: 'Public pension',
			tier: 'Tier 1',
			reup: 'Unknown',
			health: 'At Risk',
			commit: '$70M',
			aum: '$5.4B',
			lastContact: 'Unknown',
			openItems: 1,
			vdrStatus: 'Not in cohort',
		},
	],

	// ── LP panel interaction history (default for Meridian) ──
	lpInteractionHistory: [
		{
			text: '↔ VDR — Track record accessed 3×, 38 min total',
			date: 'Today 9:41 AM',
			note: 'Raise VDR source · engagement signal → Watch alert',
			vdr: true,
		},
		{
			text: '↔ VDR — Fund V PPM access (×3 sessions, 42 min)',
			date: 'Mar 21',
			note: 'Raise VDR source · alert generated in IR Workstation',
			vdr: true,
		},
		{
			text: 'Bilateral call — Q1 portfolio update',
			date: 'Mar 3',
			note: 'J. Morales · 25 min · positive sentiment',
		},
		{
			text: 'Q1 quarterly report downloaded',
			date: 'Feb 14',
			note: 'Portal access · full document view',
		},
		{
			text: 'LP annual meeting attended',
			date: 'Jan 22',
			note: 'In person · 2 Q&A questions submitted',
		},
	],

	// ── drawer content definitions ──
	drawerContents: {
		wirefollow: {
			title: 'Capital call wire follow-up',
			sub: 'Statewide Teachers Pension · Fund IV · 3 days overdue',
			fieldsLabel: 'Task context',
			fields: [
				{ label: 'Capital call issued', value: 'Mar 14, 2026' },
				{ label: 'Amount due', value: '$8.4M' },
				{ label: 'Wire deadline', value: 'Mar 18 (passed)', valueColor: 'red' },
				{ label: 'Wire confirmed', value: 'Not received', valueColor: 'red' },
			],
			email: {
				to: 'Treasurer — Statewide Teachers Pension',
				subject: 'Fund IV Capital Call — Wire Confirmation Needed',
				body: "Dear [Contact Name],\n\nI'm following up on the Fund IV capital call issued March 14 for $8.4M, deadline March 18. We have not yet received wire confirmation. Could you let us know the expected settlement date?\n\nBest,\nJ. Morales",
			},
			actions: [
				{ label: 'Copy & log', variant: 'primary' },
				{ label: 'Snooze 24h' },
				{ label: 'Escalate' },
			],
		},
		'vdr-qa-breach': {
			title: 'Q&A SLA Breach — Raise VDR source',
			sub: 'LP question in Raise VDR document room · 6 days without response',
			fieldsLabel: 'Q&A context',
			fields: [
				{ label: 'LP', value: 'Pacific Coast Foundation' },
				{
					label: 'Question',
					value: '"Clarify the management fee step-down?"',
					valueColor: 'vdr',
				},
				{ label: 'Submitted', value: 'Mar 19 in Raise VDR' },
				{
					label: 'SLA status',
					value: '5-day SLA breached by 1 day',
					valueColor: 'red',
				},
			],
			vdrBlock: {
				header: '↔ Response workflow',
				desc: 'Draft and publish your response in the Raise VDR Q&A tab. The response posts directly to the LP-facing view. The Q&A item is marked Answered in both products simultaneously.',
				flow: 'IR Workstation (triage) → Raise VDR Q&A (draft + publish) → LP-facing view (LP notified)',
			},
			actions: [
				{ label: '↔ Open Raise VDR Q&A to draft response', variant: 'vdr' },
			],
		},
		'vdr-ioi-queue': {
			title: 'IOI Received — Confirm in pipeline',
			sub: 'Hartwell Family Office · $30M · today 11:23 AM',
			fieldsLabel: 'IOI detail',
			fields: [
				{ label: 'LP', value: 'Hartwell Family Office' },
				{ label: 'Indication', value: '$30M', valueColor: 'green' },
				{ label: 'Conditions', value: 'Advisory committee by Apr 15' },
				{
					label: 'VDR status',
					value: 'IOI Submitted — awaiting confirmation',
					valueColor: 'vdr',
				},
				{
					label: 'VDR engagement',
					value: '3 sessions · 52 min · High signal',
					valueColor: 'vdr',
				},
			],
			vdrBlock: {
				header: '↔ Shared pipeline state',
				desc: 'Confirmation in Raise VDR updates the shared state, which this pipeline table reads on load.',
				flow: 'Raise VDR → localStorage → IR WS pipeline table',
			},
			actions: [
				{ label: '↔ Confirm in Raise VDR', variant: 'vdr' },
				{ label: 'Defer' },
			],
		},
		'vdr-ioi-alert': {
			title: 'IOI Submitted — Critical',
			sub: 'Hartwell Family Office · $30M · Raise VDR · today 11:23 AM',
			alertLabel: 'Critical alert',
			fieldsLabel: 'IOI detail',
			alert: {
				text: 'IOI submitted in Raise VDR · pipeline update required · confirmation needed before capital calculation refreshes',
				color: 'red',
			},
			fields: [
				{ label: 'LP', value: 'Hartwell Family Office' },
				{ label: 'Indication', value: '$30M', valueColor: 'green' },
				{ label: 'Conditions', value: 'Advisory committee by Apr 15' },
				{
					label: 'Pipeline state',
					value: 'Awaiting IR confirmation',
					valueColor: 'amber',
				},
			],
			vdrBlock: {
				header: '↔ Shared pipeline state',
				desc: 'Open Raise VDR to confirm. Once confirmed there, this pipeline table updates automatically via localStorage on next load.',
			},
			actions: [
				{ label: '↔ Open Raise VDR to confirm', variant: 'vdr' },
				{ label: 'Acknowledge' },
			],
		},
		'vdr-high-engagement': {
			title: 'High Engagement Signal — Raise VDR',
			sub: 'Meridian Endowment · 38 min · Track record 3× · today 9:41 AM',
			fieldsLabel: 'VDR engagement detail',
			fields: [
				{ label: 'Sessions today', value: '2 sessions', valueColor: 'green' },
				{ label: 'Total time', value: '38 minutes', valueColor: 'green' },
				{
					label: 'Sections accessed',
					value: 'Track Record (3×, 22 min), Strategy, Team',
				},
				{
					label: 'vs. cohort average',
					value: '3.2× above average',
					valueColor: 'green',
				},
			],
			note: '3 sessions with 38 min on track record and strategy suggests IC memo preparation. Recommended outreach: today or tomorrow.',
			email: {
				to: '[Contact] — Meridian Endowment',
				subject: 'Fund V — following up on your review',
				body: 'Hi [Contact],\n\nI wanted to follow up — happy to walk through any sections in detail or answer questions from your review.\n\nWe have a first close milestone of April 30. Would 30 minutes work this week?\n\nBest,\nJ. Morales',
			},
			vdrBlock: {
				header: '↔ Per-document breakdown in Raise VDR',
				desc: 'Full document-level engagement data (time per document, downloads, section heatmap) is available in the Raise VDR LP activity tab for this LP.',
			},
			actions: [
				{ label: 'Copy & log signal', variant: 'primary' },
				{ label: '↔ Full detail in Raise VDR', variant: 'vdr' },
			],
		},
		'carver-alert': {
			title: 'Relationship health: At Risk',
			sub: 'Carver State Pension · AIMe Health Signal',
			alertLabel: 'Signal summary',
			alert: {
				text: 'At Risk — No meaningful contact >90 days + open items',
				color: 'red',
			},
			factorsLabel: 'Top 3 contributing factors',
			emailLabel: 'Recommended outreach',
			factors: [
				{
					text: 'No meaningful contact logged in 94 days',
					weight: 'High weight · threshold is 90 days for Tier 1',
					color: 'red',
				},
				{ text: '2 open action items past due date', color: 'red' },
				{
					text: 'Quarterly report portal access declining',
					weight: 'Medium weight',
					color: 'amber',
				},
			],
			email: {
				to: '[Contact] — Carver State Pension',
				subject: 'Checking in — Fund IV portfolio update',
				body: "Hi [Contact],\n\nIt's been a few months since we last connected. A few things worth a brief conversation:\n  · Q1 portfolio performance\n  · Expected capital activity over next two quarters\n\nWould 20 minutes work in the next two weeks?\n\nBest,\nJ. Morales",
			},
			seniorEmail: {
				to: '[Contact] — Carver State Pension',
				subject: 'Portfolio update — worth a brief call',
				body: 'Hi [Contact],\n\nI wanted to reach out personally. Could we find 20 minutes in the next two weeks?\n\n[Partner Name]',
			},
			actions: [
				{ label: 'Copy & log', variant: 'primary' },
				{ label: 'Acknowledge' },
				{ label: 'Escalate to MP' },
			],
		},
		'northgate-reup': {
			title: 'Re-up score downgrade',
			sub: 'Northgate Insurance · High → Medium',
			scoreChangeLabel: 'Score movement',
			scoreChange: {
				from: { label: 'High', color: 'green' },
				to: { label: 'Medium', color: 'amber' },
			},
			factorsLabel: 'Top 3 factors',
			factors: [
				{
					text: 'DPI sensitivity flagged — current fund DPI below LP threshold',
					weight: 'High weight',
					color: 'red',
				},
				{
					text: 'Last contact 61 days ago — above 45-day Tier 1 standard',
					color: 'amber',
				},
				{
					text: 'NDA declined in Raise VDR — no behavioral signals available from VDR',
					weight: 'Medium weight · VDR signals would improve score precision',
					color: 'amber',
				},
			],
			vdrBlock: {
				header: '↔ Northgate NDA declined in Raise VDR',
				desc: 'Northgate declined NDA in Raise VDR today. This is the primary context for the re-up score decline. Review the NDA decline in Raise VDR to decide next steps.',
			},
			actions: [
				{ label: 'Create follow-up task', variant: 'primary' },
				{ label: '↔ Review NDA decline in Raise VDR', variant: 'vdr' },
				{ label: 'Override score' },
			],
		},
		'meridian-ppm': {
			title: 'PPM engagement follow-up',
			sub: 'Meridian Endowment · Fund V · Signal detected today 9:41 AM',
			fieldsLabel: 'Engagement signal',
			fields: [
				{
					label: 'Sessions',
					value: '3 sessions in 24 hrs',
					valueColor: 'green',
				},
				{ label: 'Total time', value: '42 minutes', valueColor: 'green' },
				{
					label: 'Source',
					value: 'Raise VDR document room',
					pill: { label: 'Raise VDR', color: 'vdr' },
				},
			],
			email: {
				to: '[Contact] — Meridian Endowment',
				subject: 'Fund V — following up on your review',
				body: "Hi [Contact],\n\nI hope you've had a chance to review the Fund V materials. Happy to walk through any sections.\n\nWe have a first close of April 30. Would 30 minutes work this week?\n\nBest,\nJ. Morales",
			},
			vdrBlock: {
				header: '↔ Signal source: Raise VDR',
				desc: 'Full per-document engagement breakdown available in the Raise VDR LP activity tab for this LP.',
			},
			actions: [
				{ label: 'Copy & log signal', variant: 'primary' },
				{ label: '↔ Full engagement in Raise VDR', variant: 'vdr' },
			],
		},
		'reup-high': {
			title: 'Re-up score: High',
			sub: 'AIMe score explanation',
			scorePill: { label: 'High', color: 'green' },
			scoreNote:
				'High confidence that {lp} will commit to Fund V. Maintain standard cadence and advance toward soft circle.',
			ratingBars: [
				{
					label: 'Commitment history',
					percent: 95,
					color: 'green',
					rating: 'Strong',
				},
				{
					label: 'Contact recency',
					percent: 85,
					color: 'green',
					rating: 'Strong',
				},
				{
					label: 'VDR engagement',
					percent: 78,
					color: 'green',
					rating: 'Active',
				},
				{
					label: 'Strategy fit',
					percent: 90,
					color: 'green',
					rating: 'Strong',
				},
			],
			actions: [
				{ label: 'Advance to soft circle', variant: 'primary' },
				{ label: '↔ VDR engagement detail', variant: 'vdr' },
				{ label: 'Override score' },
			],
		},
		'reup-medium': {
			title: 'Re-up score: Medium',
			sub: 'AIMe score explanation',
			scorePill: { label: 'Medium', color: 'amber' },
			scoreNote:
				'{lp} is likely to re-up but risk factors are present. Proactive outreach recommended.',
			ratingBars: [
				{
					label: 'Commitment history',
					percent: 85,
					color: 'green',
					rating: 'Strong',
				},
				{
					label: 'DPI vs. expectation',
					percent: 28,
					color: 'red',
					rating: 'Below',
				},
				{
					label: 'Contact recency',
					percent: 42,
					color: 'amber',
					rating: 'Slipping',
				},
			],
			actions: [
				{ label: 'Schedule DPI call', variant: 'primary' },
				{ label: 'Override score' },
			],
		},
		'reup-unknown': {
			title: 'Re-up score: Unknown',
			sub: 'AIMe cannot score — data gap',
			scorePill: { label: 'Unknown', color: 'gray' },
			scoreNote:
				'AIMe cannot score {lp}. Primary contact email is bouncing — Email Sync signals lost.',
			factorsLabel: 'Data gaps',
			factors: [
				{
					text: 'Primary contact email bouncing since Mar 12',
					weight: 'Blocking — contact recency cannot be computed',
					color: 'red',
				},
				{
					text: 'Not in active Raise VDR cohort — no behavioral signal data',
					weight: 'Score inputs incomplete',
					color: 'amber',
				},
			],
			actions: [{ label: 'Draft contact identification', variant: 'primary' }],
		},
	},

	// ── page metadata ──
	pageHeader: {
		title: 'My Day',
	},
};

export default fakeData;
